import { QueryType } from '@/models/query'
import { User } from '@/models/user'
import { instanceWithToken } from '@/plugins/api'
import { FileAuditRequestType } from '@/types/FileAuditRequestType'
import { PersonIdentifyRequestType } from '@/types/PersonIdentifyRequestType'
import { QueryRequestType } from '@/types/QueryRequestType'

export const saveQuery = (newQueryRequest: QueryRequestType) => {
  return instanceWithToken.post('queries', {
    body: JSON.stringify(newQueryRequest)
  })
}

export const getQueriesStatus = async () => {
  const response = await instanceWithToken.get('queries')
  const responseBody: QueryType[] = await response.json()
  return responseBody.sort(
    (queryA, queryB) =>
      new Date(queryB.createdAt).getTime() -
      new Date(queryA.createdAt).getTime()
  )
}

export const getFileLink = async (requestId: string) => {
  const response = await instanceWithToken.get(`file_vault/${requestId}`)
  const responseBody: string = await response.text()
  return responseBody
}

export const auditFile = async (auditRequest: FileAuditRequestType) => {
  const response = await instanceWithToken.post(`file_vault`, {
    body: JSON.stringify(auditRequest)
  })
  const responseBody: string = await response.json()
  return responseBody
}

export const getUser = async () => {
  const response = await instanceWithToken.get('me')
  const responseBody: User = await response.json()
  return responseBody
}

export const personIdentify = async (request: PersonIdentifyRequestType) => {
  const response = await instanceWithToken.post(`person_identify`, {
    body: JSON.stringify(request)
  })
  const responseBody: string = await response.json()
  return responseBody
}
